/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_AddressInputs */



/**
* | output |
* | --- |
* | "Address" |
*
* @param {Tfield_AddressInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_address = /** @type {((inputs?: Tfield_AddressInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_AddressInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Adresse")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dirección")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Endereço")
	if (locale === "it") return /** @type {LocalizedString} */ ("Indirizzo")
	return /** @type {LocalizedString} */ ("Address")
});